// const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const API_BASE_URL = '/api';

export const fetchCustomers = async () => {
  try {
    // Constructs the full URL for the /client-names endpoint.
    console.log(API_BASE_URL)
    const response = await fetch(`${API_BASE_URL}/bigquery/client-names`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    // Expecting data in the format: [{"ClientCode": "C1", "ClientName": "ADP"}, ...]
    return await response.json(); 

  } catch (e) {
    console.error("Failed to fetch client data:", e);
    // In case of an error, we throw it so the component using this service can handle it.
    throw e;
  }
};


export const postChatMessage = async (clientCode, query, chatHistory, conversationId, languageCode = 'en') => {
  try {
    // Constructs the full URL for the /chat/ endpoint.
    const response = await fetch(`${API_BASE_URL}/chat/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
      },
      body: JSON.stringify({ 
        clientCode, 
        query, 
        chatHistory: chatHistory,
        conversationId: conversationId,
        language_code: languageCode  // ✅ Send selected language code
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const detail = errorData.detail || `HTTP error! status: ${response.status}`;
      throw new Error(detail);
    }
    
    return await response.json();

  } catch (e) {
    console.error("Failed to post chat message:", e);
    throw e;
  }
};



/**
 * **NEW FUNCTION**
 * Posts the data ingestion form to the backend.
 * @param {object} formData The data from the form.
 * @returns {Promise<object>} The backend's response.
 */
export const transferPalantirData = async (formData) => {
    const payload = {
        dataset_rid: formData.datasetRid,
        table_name: formData.tableName,
        row_limit: parseInt(formData.rowCount, 10) || 0,
        branch_name: "master",
        format_type: "CSV",
        write_disposition: "WRITE_TRUNCATE"
    };

    try {
        const response = await fetch(`${API_BASE_URL}/palantir-bq/transfer`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ detail: 'An unknown error occurred' }));
            throw new Error(errorData.detail);
        }

        return await response.json();

    } catch (e) {
        console.error("Failed to submit data transfer request:", e);
        throw e;
    }
};


export const copyPalantirDataset = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/palantir-bq/copy-dataset`, {
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ detail: 'An unknown error occurred' }));
            throw new Error(errorData.detail);
        }

        return await response.json();

    } catch (e) {
        console.error("Failed to submit copy dataset request:", e);
        throw e;
    }
};


/**
 * **NEW FUNCTION**
 * Triggers the document ingestion pipeline for a specific client.
 * @param {string} clientName The name of the client.
 * @returns {Promise<object>} The backend's response.
 */
export const ingestClientDocs = async (clientName) => {
    const payload = { clientName };
    try {
        const response = await fetch(`${API_BASE_URL}/ingestion/ingest-client-docs`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ detail: 'An unknown error occurred' }));
            throw new Error(errorData.detail);
        }
        return await response.json();
    } catch (e) {
        console.error("Failed to submit ingest client docs request:", e);
        throw e;
    }
};


/**
 * **NEW FUNCTION**
 * Gets a signed URL for a specific file from the backend.
 * @param {string} filename The name of the file.
 * @param {string} sourceType The type of the source (e.g., 'calendars').
 * @returns {Promise<object>} The backend's response containing the signed URL.
 */
export const generateSignedUrl = async (filename, sourceType) => {
    const payload = { filename, source_type: sourceType };
    try {
        const response = await fetch(`${API_BASE_URL}/chat/generateSignedUrl`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'accept': 'application/json' },
            body: JSON.stringify(payload)
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ detail: `HTTP error! status: ${response.status}` }));
            throw new Error(errorData.detail);
        }
        return await response.json();
    } catch (e) {
        console.error("Failed to generate signed URL:", e);
        throw e;
    }
};


/**
 * **NEW FUNCTION**
 * Triggers the deletion of a folder's contents.
 * @param {string} folderName The name of the folder to delete.
 * @returns {Promise<object>} The backend's response.
 */
export const deleteFolderInfo = async (folderName) => {
    const payload = { folder_name: folderName };
    try {
        const response = await fetch(`${API_BASE_URL}/ingestion/deleteFolderInfo`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ detail: 'An unknown error occurred' }));
            throw new Error(errorData.detail);
        }
        return await response.json();
    } catch (e) {
        console.error("Failed to submit delete folder request:", e);
        throw e;
    }
};


export const submitFeedback = async (payload) => {
  try {
    const response = await fetch(`${API_BASE_URL}/feedback/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error: ${response.status}`);
    }

    return await response.json();
  } catch (e) {
    console.error("Failed to submit feedback:", e);
    throw e;
  }
};
